if (!customElements.get('cart-drawer-suggestion-add')) {
  customElements.define(
    'cart-drawer-suggestion-add',
    class CartDrawerSuggestionAdd extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.classList.contains('loading')) return;

        this.button.classList.add('loading');
        this.button.disabled = true;
        this.clearError();

        const body = JSON.stringify({
          items: [{ id: this.dataset.variantId, quantity: 1 }],
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || window.cartStrings.error);
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-suggestion', cartData: response });
            this.updateCartIconBubble();
          })
          .catch(() => {
            this.showError(window.cartStrings ? window.cartStrings.error : 'Something went wrong, please try again.');
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.disabled = false;
          });
      }

      updateCartIconBubble() {
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const source = html.querySelector('.shopify-section');
            const target = document.getElementById('cart-icon-bubble');
            if (!source || !target) return;
            const targetInner = target.querySelector('.shopify-section') || target;
            targetInner.innerHTML = source.innerHTML;
          })
          .catch((e) => console.error(e));
      }

      showError(message) {
        const container = this.closest('.cart-drawer__suggestion') || this;
        let errorText = container.querySelector('.cart-drawer__suggestion-error');
        if (!errorText) {
          errorText = document.createElement('small');
          errorText.className = 'cart-drawer__suggestion-error';
          container.appendChild(errorText);
        }
        errorText.textContent = message;
      }

      clearError() {
        const container = this.closest('.cart-drawer__suggestion') || this;
        const errorText = container.querySelector('.cart-drawer__suggestion-error');
        if (errorText) errorText.remove();
      }
    }
  );
}